import { useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';

export const useSessionEnforcement = () => {
  const { user, logout, isSuperAdmin } = useAuth();

  useEffect(() => {
    if (isSuperAdmin) return; // Super admins exempt — they need multi-app sessions

    const interval = setInterval(async () => {
      if (user) {
        const { data, error } = await supabase
          .from('sessions')
          .select('id')
          .eq('user_id', user.id);

        if (error) {
          console.error('Error fetching session:', error);
          return;
        }

        if (data.length === 0) {
          alert("You've been logged out because your account was accessed from another device.");
          logout();
        }
      }
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, [user, logout, isSuperAdmin]);
};
